<!-- 余料处理方式 -->
<template>
  <BaseFormItem
    isShowRequiredIcon
    class="surplus-material"
    :label="label"
    labelTitle=" "
    :labelTips="fields.labelTips"
  >
    <BaseRadioGroup v-model="val" @change="handleEmit">
      <el-radio-button
        v-for="item in fields.options"
        :key="item.value"
        :label="item.value"
      >{{ item.label }}</el-radio-button>
    </BaseRadioGroup>
  </BaseFormItem>
</template>

<script>
import { getSMTFields, labelWarp } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      val: this.value,
    }
  },
  computed: {
    fields() {
      return getSMTFields('oddments_type')
    },
    label() {
      // 换行展示label
      return labelWarp(this.fields.label, 2)
    },
  },
  watch: {
    value(newVal) {
      this.val = +newVal
    }
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.$emit('change', val)
    },
  }
}
</script>
